// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"3d87d331","419":"36de01ee","439":"045b8992","458":"c3827035","519":"92e9529a","591":"fac4a88e","774":"4a404c06","787":"42ed2116"}[chunkId] + ".chunk.js";
};